<template>
  <div>
    <UnderConstruction />
  </div>
  <!-- <div class="classroom-page">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li>
            <router-link :to="{name: 'ViewDetailSubject'}">Lớp học</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="ss-banner ss-banner--ebook"
      :style="{background: `url(${imgBanner}) center center / cover no-repeat`}"
    ></div>
    <div class="container list-class">
      <div class="row">
        <div class="col-lg-6 col-md-10 add-search display-flex">
            <button
                type="button"
                class="btn btn-primary btns font-sanpro-semibold display-flex-center justify-content-center"
                data-toggle="modal" 
                data-target=".join-class"
            >
                <i class="fal fa-plus font-size-23 margin-right-fa-plus"></i>  Tham gia lớp
            </button>
            <ModalJoinClass />
            <div class="form">
                <form class="form-training">
                <input  v-model.lazy="keyword" v-debounce="300" type="text" placeholder="Tìm kiếm" required="required" />
                <button type="submit">
                    <i class="fa fa-search secondary-color-blue"></i>
                </button>
                </form>
            </div>
        </div>
        <div class="col-lg-6">
        </div>
        <div v-if=" classLists && classLists.list && classLists.list.length>0" class="col-lg-6 col-md-6 col-12 " v-for="(item, index) in classLists.list" :key="index">
            <div class="item-class display-flex">
              <router-link :to="{ path: `/lop-hoc/mon-${item.classSchoolSubjectId}/noi-dung` }">
                  <div class="info-left display-flex">
                      <img src="@/assets/img/icon-list.png" alt />
                      <div class="info-class text-left">
                            <h2 class="primary-color font-sanpro-semibold font-size-16">{{item.name}}</h2>
                            <h3
                            class="secondary-color-txt font-family-Semibold font-size-14"
                            >{{item.school}}</h3>
                            <h3 class="primary-color font-family-Semibold font-size-14">{{item.numberOfStudent}}</h3>
                      </div>
                </div>
              </router-link>
              <div class="tool-class">
                  <div class="dropdown dropdown-account">
                      <button
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          class="dropdown-toggle"
                      >
                          <i class="fas fa-ellipsis-h"></i>
                      </button>
                      <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                          <a href="javascript:;" class="dropdown-item" role="button">Xem thông tin</a>
                          <a @click="leaveClass(item.classSchoolSubjectId)" href="javascript:;" class="dropdown-item" role="button">Rời lớp</a>
                          <a href="javascript:;" class="dropdown-item" role="button">Báo cáo</a>
                      </div>
                  </div>
              </div>
            </div>
        </div>
        <h3  v-if="  classLists && classLists.list && classLists.list.length===0"  class="secondary-color-txt font-sanpro-semibold font-size-20 mt-2 mb-4 col-lg-12 text-center">
          Bạn chưa tham gia lớp nào
        </h3>
		      <p class="col-12 text-center pagiination-training">
            <Pagination
              @eventPagination="getClassPagination"
              :totalPage="pagingData.totalPage"
              :page="pagingData.pageIndex"
            />
          </p>
      </div>
    </div>
  </div> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import ModalJoinClass from "../_components/modalClass/ModalJoinClass";
import debounce from "@/directives/debounce";
import Pagination from "@/components/Pagination.vue";
import { apiLeaveClass } from "../_api";
const imgBanner = require("@/assets/img/class-bg.png");
import UnderConstruction from "@/views/pages/UnderConstruction"
export default {
  name: "ViewListClass",
  components: {
    ModalJoinClass,
    Pagination,
    UnderConstruction
  },
  directives: { debounce },
  data() {
    return {
      imgBanner,
      pagingData:{},
      keyword:""
    };
  },
   computed: {
    ...mapGetters({
      classLists: STORE_KEY + "/classLists",
      getParamListSchool: STORE_KEY + "/getParamListSchool",
    })
  },
  watch:{
    classLists(newVal,oldVal){
      if(newVal){
         this.pagingData = newVal.paging; 
      }
    },
    keyword: "classSerach",
    getParamListSchool: "fetchSchoolList"
  },
  mounted() {
    // this.actionGetListClass({keyword:"",pageIndex:1,pageSize:10,sort:"",direction:""});
      this.actionSetParamListSchool({ ...this.getParamListSchool, pageIndex: 1, pageSize:10});
  },
   methods: {
    ...mapActions(`${STORE_KEY}`, ["actionGetListClass","actionSetParamListSchool"]),
    ...mapActions(`common`, ["setLoading"]),
    fetchSchoolList(){
      this.setLoading(true);
      this.actionGetListClass(this.getParamListSchool)
      .finally(() => {
        this.setLoading(false);
      });
    },
    classSerach() {
      this.actionSetParamListSchool({ ...this.getParamListSchool, keyword: this.keyword });
    },
    leaveClass(classSchoolSubjectId){
      apiLeaveClass({classSchoolSubjectId:classSchoolSubjectId})
      .then(res => {
         if (res.status === "success") {
            this.actionGetListClass(this.getParamListSchool)
            this.$toast.success('Đã rời lớp');
         }
      });
    },
    getClassPagination(value) {
      this.setLoading(true);
      this.actionSetParamListSchool({ ...this.getParamListSchool, pageIndex: value }).finally(
        () => {
          this.setLoading(false);
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.list-class {
  margin-top: 49px;
  .add-search {
    margin-bottom: 37px;
    .btns {
      font-size: 15px !important;
      background-color: #124abe;
      color: #fff;
      text-align: center;
      border-radius: 20px;
      text-decoration: none;
      width: 160px;
      margin-right: 10px;
      height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .form {
      height: 30px;
      width: 377px;
      .form-training {
        position: relative;
      }
      input {
        border-radius: 20px;
        height: 30px;
        padding: 0 35px 0 12px;
        top: 0;
        left: 0;
        border: 0;
        color: #40505e;
        outline: 0;
        background-color: #f3f6fb;
        font-size: 15px;
        width: 100%;
        position: static;
      }
      button {
        position: absolute;
        top: 4px;
        z-index: 1;
        background-color: transparent;
        border: 0;
        color: #124abe;
        outline: 0;
        right: 13px;
        font-size: 14px;
      }
    }
  }
  .item-class{
        padding: 17px 0;
        border-radius: 5px;
        margin: 0 0px 18px 0px;
        position: relative;
        &:hover{
          background: #f3f6fb;
        }
        &:focus{
          background: #f3f6fb;
        }
      h2{
          margin-bottom: 12px
      }
       img{
                height: 78px;
                margin: 0 12px 0 18px;
          }
      .into-left{
            img{
                height: 78px;
                margin: 0 12px 0 18px;
            }
      }
      .tool-class{
            position: absolute;
            top: 0px;
            right: 10px;
      }
  }
}
.dropdown button {
  width: 30px;
  background:none;
  color: #879AA9;
  font-size: 14px;
  text-align: center;
  border: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 30px;
  height: 30px;
  outline: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #124abe;
  text-decoration: none;
  background: none;
}
.dropdown button:focus {
    background: none !important;
    color: #124ABE;
}
.dropdown-toggle::after {
    display:none;
}
.dropdown-menu {
  padding: 0rem 0 0.5rem;
  margin: 0.125rem 0 0;
  box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
  transform: translate3d(-95px, 30px, 0px) !important;
}
@media (max-width: 425px){
  .dropdown-menu {
    padding: 0rem 0 0.5rem;
    margin: 0.125rem 0 0;
    box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
    transform: translate3d(167px, 30px, 0px) !important;
  }
  .list-class .add-search{
      display: block;
      .btns{
         margin-bottom: 20px;
      }
  }
}
</style>